module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/carton1.c8d0ace3.jpg";